// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__k84wA","form":"styles_form__1qGGd"};